module.exports = __webpack_public_path__ + "assets/CenterOfRotationDetailed.1e5a980fc36eb4f14f901ad2e6e05cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CenterOfRotationDetailed.png
// module id = 477
// module chunks = 0